module.exports = __webpack_public_path__ + "static/media/sac3.2cedc6e4.png";